import { cn } from "@/lib/utils";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
    nopulse?: boolean;
}

function Skeleton({ className, nopulse = false, ...props }: SkeletonProps) {
    return (
        <div
            className={cn(
                "rounded-md bg-foreground/50",
                !nopulse && "animate-pulse",
                className
            )}
            {...props}
        />
    );
}

export { Skeleton };
